import { render, staticRenderFns } from "./serviceHall.vue?vue&type=template&id=88de98b8&scoped=true&"
import script from "./serviceHall.vue?vue&type=script&lang=js&"
export * from "./serviceHall.vue?vue&type=script&lang=js&"
import style0 from "./serviceHall.vue?vue&type=style&index=0&id=88de98b8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88de98b8",
  null
  
)

export default component.exports